module.exports = __webpack_public_path__ + "img/cat1.6251451.png";